import React from 'react';

const PinkInfoSection = () => {
  return (
    <section className="py-8 sm:py-12 md:py-16" style={{ backgroundColor: '#db0058' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main heading */}
        <div className="text-center mb-6 sm:mb-8 md:mb-10">
          <p className="text-white text-base sm:text-lg md:text-xl leading-relaxed max-w-3xl mx-auto font-medium">
            Forget what you've you been told about consumer data — because data is only ever data,
            unless it's high quality, accurate and brought to life in the right way.
          </p>
        </div>
        
        {/* Two column content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10">
          {/* Left column */}
          <div className="text-white">
            <p className="text-sm sm:text-base leading-relaxed">
              At Lloyd James Data Consultancy, we're here to redefine consumer data lists and there potential.
              We begin by taking your customer data and analysing it — mapping it across our RESIDENT product
              to profile it, model it and create your target audience. We will provide you with an accurate market profile
              and details of where, why and how to engage with your new & existing customers.
            </p>
          </div>
          
          {/* Right column */}
          <div className="text-white">
            <p className="text-sm sm:text-base leading-relaxed">
              By putting people first, we're able to make consumer data work harder for you, and unlock its true power to
              deliver tangible business outcomes. As more than just a data provider, but also more than just a media
              company, we're able to deliver a full-service data consultancy that's tailored precisely to your
              objectives.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PinkInfoSection;